/**
 * Captures whether the current page load arrived via a legacy `.html` URL.
 * `main.tsx` writes the original path into sessionStorage before React mounts.
 * We read + clear it once here so multiple consumers (toast, 404 page banner)
 * can share the same value without racing. On first read we also log the
 * hit for admin monitoring.
 */
import { logUrlEvent } from './urlMonitor';

let consumed = false;

export function consumeLegacyRedirectOrigin(): string | null {
  if (consumed) return null;
  consumed = true;
  let value: string | null = null;
  try {
    value = sessionStorage.getItem("legacyHtmlRedirect");
    if (value) sessionStorage.removeItem("legacyHtmlRedirect");
  } catch {
    value = null;
  }
  if (value) logUrlEvent('legacy_html', value);
  return value;
}
